import styled from 'styled-components';

export const StyledHistoryWrapper = styled.div`
	max-height: 70vh;
	min-height: 30rem;
	overflow-y: auto;
`;
